import styled from "@emotion/styled";
import { Link } from "react-router-dom";
import FlexCenter from "shared/components/Layout/components/FlexCenter";
import { COLOR_BLACK, COLOR_GREY_5 } from "shared/theme/colors";

export const StyledLink = styled(Link)`
  width: 100%;
  color: ${COLOR_BLACK};
  text-decoration: none;
`;

export const StyledSpinnerWrapper = styled(FlexCenter)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

export const StyledManageArticlesLayout = styled.div`
  display: grid;
  grid-template-columns: minmax(auto, 250px) 1fr;
  column-gap: 16px;
  overflow-x: auto;
  width: 100%;
  height: 78vh;
  position: relative;

  &:before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100% !important;
    height: 1px;
    background-color: ${COLOR_GREY_5};
  }
`;
